import * as React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

/**
 * Four-pane grid glyph for the Dashboard sidebar item (Figma "grid-layout",
 * node 16306:68615). Built on MUI's `SvgIcon` so it takes the nav's
 * `sx`/`fontSize`/`color` props like the rest; the path uses `currentColor`,
 * so the sidebar tints it via `palette.icon` / `palette.iconActive`.
 *
 * The artwork is 16×16 but the viewBox is 18×18 with the art inset by 1: the
 * sidebar renders nav icons at `fontSize: 18`, so the 1-unit margin makes the
 * ink land at exactly the design's 16px instead of filling all 18. This mirrors
 * how MUI's own icons keep padding inside their 24-unit viewBox — without it
 * these glyphs read noticeably larger than their neighbours.
 */
const GridLayoutIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 18 18" {...props}>
    <path transform="translate(1 1)" d="M6 9C6.6 9 7 9.4 7 10V15C7 15.6 6.6 16 6 16H1C0.4 16 0 15.6 0 15V10C0 9.4 0.4 9 1 9H6ZM15 9C15.6 9 16 9.4 16 10V15C16 15.6 15.6 16 15 16H10C9.4 16 9 15.6 9 15V10C9 9.4 9.4 9 10 9H15ZM2 14H5V11H2V14ZM11 11V14H14V11H11ZM6 0C6.6 0 7 0.4 7 1V6C7 6.6 6.6 7 6 7H1C0.4 7 0 6.6 0 6V1C0 0.4 0.4 0 1 0H6ZM15 0C15.6 0 16 0.4 16 1V6C16 6.6 15.6 7 15 7H10C9.4 7 9 6.6 9 6V1C9 0.4 9.4 0 10 0H15ZM2 5H5V2H2V5ZM11 5H14V2H11V5Z" />
  </SvgIcon>
);

export default GridLayoutIcon;
